import { Row } from '@tanstack/react-table';
import { ReactNode } from 'react';

export const TableRowWrapper = <T,>({
  children,
  enableRowClickable,
  row,
  onClickRow,
  disableRow,
  ...props
}: {
  children: ReactNode;
  index: number;
  enableRowClickable?: boolean;
  row: Row<T>;
  onClickRow?: (value: Row<T>) => void | undefined;
  disableRow?: (value: Row<T>) => boolean;
}) => {
  let isRowDisabled = false;
  if (disableRow) {
    isRowDisabled = disableRow(row);
  }
  return (
    <tr
      className={`group border-b bg-white even:bg-gray-50 dark:bg-gray-900 dark:even:bg-gray-800 dark:border-gray-700 ${
        enableRowClickable && !isRowDisabled
          ? 'cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700'
          : ''
      }`}
      data-testid="table-row"
      onClick={() => {
        if (enableRowClickable && onClickRow) {
          onClickRow(row);
        }
      }}
      {...props}
    >
      {children}
    </tr>
  );
};
